import type { MCCVarSharingConfig } from 'features/traffic/campaigns/campaign-configs/types';
import { isLinkTypeAndValueString } from 'features/traffic/campaigns/content/common-components/RefTaggedLinkEditor/ref-tagged-link-utils';
import type {
  FeaturedBrandsContent,
  FeaturedBrandsFlavor,
  FeaturedBrandsGlobalContent,
  FeaturedBrandsShareableFieldsMetaMap,
  ProgramAsins,
} from '../types';

export const featuredBrandsVarSharingConfig: MCCVarSharingConfig<
  FeaturedBrandsShareableFieldsMetaMap,
  FeaturedBrandsContent,
  FeaturedBrandsGlobalContent
> = {
  checkIfDefaultSharingIsSupported: () => true,
  defaultSharingEnabled: true,
  shareableFields: {
    brandName: {
      checkIfMatchEligible: ({ flavor, testFlavor, flavorIndex, testFlavorIndex }) => {
        if (!flavor.active) return false;
        if (!testFlavor.active) return false;
        if (flavorIndex === testFlavorIndex) return false;
        return true;
      },
      formatValue: (value) => `${value}`,
      getContentPath: () => 'content.brandName',
      getField: (flavor: FeaturedBrandsFlavor) => flavor.content.brandName,
      getShareableFieldPaths: ({ otherFlavor, otherFlavorIndex, referenceFlavor }) => {
        if (!otherFlavor.active) return [];
        if (otherFlavor.scheduling.marketplace !== referenceFlavor.scheduling.marketplace) return [];
        return [
          `flavors[${otherFlavorIndex}].content.brandName`,
        ]; // Only share brand name if the other flavor is active. Otherwise, don't share brand name. This is to prevent sharing the same brand name across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names
      },
      isDefaultShareable: true,
      valueFilterFn: (v): v is string => typeof v === 'string',
    },
    linkTypeAndLinkTypeValue: {
      checkIfMatchEligible: ({ flavor, testFlavor, flavorIndex, testFlavorIndex }) => {
        if (!flavor.active) return false;
        if (!testFlavor.active) return false;
        if (flavorIndex === testFlavorIndex) return false;
        return true;
      },
      formatValue: (value) => `${value}`,
      getContentPath: () => 'content.linkTypeAndLinkTypeValue',
      getField: (flavor: FeaturedBrandsFlavor) => flavor.content.linkTypeAndLinkTypeValue,
      getShareableFieldPaths: ({ otherFlavor, otherFlavorIndex, referenceFlavor }) => {
        if (!otherFlavor.active) return [];
        if (otherFlavor.scheduling.marketplace !== referenceFlavor.scheduling.marketplace) return [];
        return [
          `flavors[${otherFlavorIndex}].content.linkTypeAndLinkTypeValue`,
        ]; // Only share brand name if the other flavor is active. Otherwise, don't share brand name. This is to prevent sharing the same brand name across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names across multiple flavors. We should be able to share brand names across multiple flavors without having to share brand names across multiple flavors. This is a temporary workaround until we have a better solution for sharing brand names
      },
      isDefaultShareable: true,
      valueFilterFn: isLinkTypeAndValueString,
    },
    programAsins: {
      checkIfMatchEligible: ({ flavor, testFlavor, flavorIndex, testFlavorIndex }) => {
        if (!flavor.active) return false;
        if (!testFlavor.active) return false;
        if (flavorIndex === testFlavorIndex) return false;
        return true;
      },
      formatValue: (value: ProgramAsins[]) =>
        value
          .map(
            (item, _) =>
              `program: ${item.program}\n` + `primaryAsin: ${item.primaryAsin}\n` + `backupAsins: [${item.backupAsins.join(', ')}]`,
          )
          .join('\n\n'),
      getContentPath: () => 'content.programAsins',
      getField: (flavor: FeaturedBrandsFlavor) => flavor.content.programAsins,
      getShareableFieldPaths: ({ otherFlavor, otherFlavorIndex, referenceFlavor }) => {
        if (!otherFlavor.active) return [];
        if (otherFlavor.scheduling.marketplace !== referenceFlavor.scheduling.marketplace) return [];
        return [
          `flavors[${otherFlavorIndex}].content.programAsins`,
        ];
      },
      isDefaultShareable: true,
      valueFilterFn: (v): v is ProgramAsins[] =>
        Array.isArray(v) &&
        v.every((item) => typeof item === 'object' && item !== null && 'program' in item && 'primaryAsin' in item && 'backupAsins' in item),
    },
  },
};
